export class RemitoVehicle {
  // public vinSeleccionado: Array<Vin>;
  public nroRemito: string;
  public origenCode: string;
  public origenDesc: string | null;
  public ptoEmision: string | null;
  public fecGen: Date | null;
  public clase: string | null;
  public observacion: string | null;
  public cancelarObservacion: string | null;
  public destinatarioCode: string | null;
  public destinatarioDesc: string | null;
  public transporteCode: string | null;
  public transporteDesc: string | null;
  public impresorasCode: string | null;
  public impresorasDesc: string | null;
  public estadoRemito: string | null;
  public vinLetras: string | null;
  public vinNumeros: string | null;
  public anioModelo: string | null;
  public descModelo: string | null;
  public descVehiculo: string | null;
  public colorExt: string | null;
  public colorInt: string | null;
  public nroMotor: string | null;
  public vehType: string | null;

  static transformRemitoVehicle(data: any) {
    let vehicle: RemitoVehicle = new RemitoVehicle();
    vehicle.nroRemito = data.nroRemito.toString();
    vehicle.origenCode = data.codOrigen;
    vehicle.origenDesc = data.descOrigen;
    vehicle.ptoEmision = data.ptoEmision;
    vehicle.clase = data.clase.toUpperCase();
    vehicle.observacion = data.observacion;
    vehicle.cancelarObservacion = data.cancelarObservacion;
    vehicle.destinatarioCode = data.codDestino;
    vehicle.destinatarioDesc = data.nombreDestino;
    vehicle.transporteCode = data.codTransp;
    vehicle.transporteDesc = data.nombreTransp;
    vehicle.impresorasCode = data.impresoraCode;
    vehicle.impresorasDesc = data.impresoraDesc;
    vehicle.estadoRemito = data.estadoRemito;
    vehicle.vinLetras = data.vinLetras;
    vehicle.vinNumeros = data.vinNumeros;
    vehicle.descVehiculo = data.descVehiculo;
    vehicle.anioModelo = data.anioModelo;
    vehicle.descModelo = data.descModelo;
    vehicle.colorExt = data.colorExt;
    vehicle.colorInt = data.colorInt;
    vehicle.nroMotor = data.nroMotor;
    vehicle.vehType = data.remitoType;

    if (data.fecGen != undefined) {
      vehicle.fecGen = new Date(data.fecGen);
    }

    return vehicle;
  }

}

export class Vin {
  public id: number | null;
  public vinLetras: string | null;
  public vinNumeros: string | null;
  public anioModelo: string | null;
  public descModelo: string | null;
  public descVehiculo: string | null;
  public colorExt: string | null;
  public colorInt: string | null;
  public nroMotor: string | null;
}
